// @flow

import React from 'react';

import HeaderLogo from 'app/viewport/components/Header/HeaderLogo';
import {
  HeaderBlockContainer,
  HeaderBlockHeaderLinks,
  HeaderBlockInnerWrapper,
  HeaderBlockMenuControls,
  HeaderSignUpCta,
} from 'app/viewport/components/Header/HeaderBlock';

import type { HeaderLinkItemProps } from 'app/viewport/components/Header/HeaderLinks';

type Props = {
  actions: HeaderLinkItemProps[],
};

const HeaderAuth = (props: Props) => {
  const { actions } = props;

  return (
    <HeaderBlockContainer>
      <HeaderBlockInnerWrapper kind="justify">
        <HeaderBlockMenuControls>
          <HeaderLogo />
        </HeaderBlockMenuControls>

        <HeaderBlockHeaderLinks>
          {actions.map((action, idx) => {
            return (
              <HeaderSignUpCta href={action.href} key={idx}>
                {action.title}
              </HeaderSignUpCta>
            );
          })}
        </HeaderBlockHeaderLinks>
      </HeaderBlockInnerWrapper>
    </HeaderBlockContainer>
  );
};

export default HeaderAuth;
